/**
 * The type of field.
 *
 * Entity = a typical field such as Candidate.name
 *
 * Signature = a signature field such as docusign.name
 *
 * DocumentSender = the sender of the document, for Bullhorn this is like the CorporateUser
 *
 * Script = a field linked to a script such as custom.kpScriptFields.myScript
 *
 * Image = a field linked to an image belongs to the kpImageFields entity
 *
 * Conditional = a conditional field belongs to the kpConditionalFields entity
 */
export enum FieldType {
  /**
   * A typical field such as Candidate.name
   */
  Entity,

  /**
   * A signature field such as docusign.name
   */
  Signature,

  /**
   * The sender of the document, for Bullhorn this is like the CorporateUser
   */
  DocumentSender,

  /**
   * A field linked to a script such as custom.kpScriptFields.myScript
   */
  Script,

  /**
   * A field linked to an image belongs to the kpImageFields entity
   */
  Image,

  /**
   * A conditional field belongs to the kpConditionalFields entity
   */
  Conditional,

  /**
   * An AiAssist field belongs to the kpAiAssistFields entity
   */
  AiAssist,
}
